import { render, staticRenderFns } from "./Caged.vue?vue&type=template&id=2a671c12&scoped=true&"
import script from "./Caged.vue?vue&type=script&lang=js&"
export * from "./Caged.vue?vue&type=script&lang=js&"
import style0 from "./Caged.vue?vue&type=style&index=0&id=2a671c12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a671c12",
  null
  
)

export default component.exports